export const formatDate = (input: string | number | Date): string => {
  if (!input) return "";

  const date = new Date(input);

  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};